<template lang="pug">
.dev-doc--screen
  .row(v-if='webhookList.length > 0')
    .col-12
      .text-end
        button.btn.btn-primary(
          data-bs-target='#new-developer-webhook-modal'
          data-bs-toggle='modal'
        ) {{ $t('pages.manageWebhooks.newWebhook') }}
    .col-12.mt-3
      manage-webhooks-card-table.mb-5(
        :data='webhookList'
        @listWebhooks='fetchWebhooksList'
      )
      simple-paginator.mt-3(:payload='payload' @navigate='fetchWebhooksList')
  .row(v-else)
    .col-12
      .text-center.mt-5
        img.img(
          src='/img/ilustrations/empty-applications.svg'
          style='max-height: 260px'
        )
        p.m-auto.mt-4.mb-3(style='max-width: 450px') {{ $t('pages.manageWebhooks.noWebhooks') }}
        button.btn.btn-primary(
          data-bs-target='#new-developer-webhook-modal'
          data-bs-toggle='modal'
        ) {{ $t('pages.manageWebhooks.newWebhook') }}

  new-developer-webhook-modal#new-developer-webhook-modal(
    @refresh='fetchWebhooksList'
    @showInfoModal='openCreatingWebhookInfoModal'
    ref='newDeveloperWebhookModal'
  )
  creating-webhook-info-modal#creating-webhook-info-modal(
    @closed='fetchWebhooksList'
    ref='creatingWebhookInfoModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import WebhookService from '@/services/WebhooksService';
// eslint-disable-next-line max-len
import TableComponent from '@/ui/organisms/Table.vue';
import IconEnviromentClient from '@/ui/atoms/IconEnviromentClient.vue';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';
// eslint-disable-next-line max-len
import ManageWebhooksCardTable from '@/modules/account/components/organisms/card-table/ManageWebhooksCardTable.vue';
import NewDeveloperWebhookModal from '@/modules/account/components/organisms/modals/NewDeveloperWebhookModal.vue';
import CreatingWebhookInfoModal from '@/modules/account/components/organisms/modals/CreatingWebhookInfoModal.vue';

export default {
  name: 'ManageWebhooks',
  components: {
    Icon,
    NewDeveloperWebhookModal,
    IconEnviromentClient,
    TableComponent,
    SimplePaginator,
    ManageWebhooksCardTable,
    CreatingWebhookInfoModal,
  },

  data() {
    return {
      webhookList: [],
      payload: {},
    };
  },
  created() {
    this.$store.dispatch(
      'page/setTitle',
      this.$t('pages.manageWebhooks.title')
    );
    this.$store.dispatch('page/setHead', this.$t('pages.manageWebhooks.head'));
    this.$store.dispatch('page/setClass', 'account developer');
    this.fetchWebhooksList();
  },
  methods: {
    async fetchWebhooksList(page = 1) {
      this.$loading(true);
      const params = new URLSearchParams({
        page,
      });
      const result = await WebhookService.list(params.toString());
      this.payload = result.data;
      this.webhookList = result.data.data;
      this.$loading(false);
    },
    openCreatingWebhookInfoModal() {
      this.$refs.creatingWebhookInfoModal.$refs.modal.open();
    },
  },
};
</script>
<style scoped lang="stylus">
@media screen and (max-width: 768px)
  .table
    tbody
      tr
        position: relative
        display: flex
        flex-direction: row
        flex-wrap: wrap
        padding-left: 0
        td
          padding-left: 13px
          flex: 0 0 80%
          &.action
            position: absolute
            top: 35px
            right: -55px
            padding: 0
</style>
